export default __webpack_public_path__ + "static/step-1-b381466fc7f9894454d019b50b671c03.png";